
/* eslint-disable */
import styles from './style.module.scss';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { t } from '@web-solutions/module-localization';
import { useNav } from 'src/onboarding/hooks/nav';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { useStore } from 'src/onboarding/store/store';
import { getAgeGroup } from 'src/onboarding/helpers/getAgeGroup';
import Analytics from '@web-solutions/module-analytics';

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const born = useStore((state) => state.born);

  const genderAge = (
    <span className={styles.highlight}>
      {t('onboarding.feelLike.subTitle.start', {
        age: getAgeGroup(born, true),
      })}
    </span>
  );

  return (
    <div className={styles.page}>
      {currentIndex !== 0 && (
        <div className={styles.back} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={styles.wrapperInfo}>
        <Title className={styles.title}>{t('onboarding.feelLike.title')}</Title>
        <Text semibold className={styles.description}>
          {genderAge} {t('onboarding.feelLike.subTitle.middle')}{' '}
          <span className={styles.highlight}>
            {t('onboarding.feelLike.subTitle.calmCortisol')}{' '}
          </span>
          {t('onboarding.feelLike.subTitle.end')}
        </Text>
      </div>
      <div className={styles.image}></div>
      <div className={styles.continue}>
        <div className={styles.blur}></div>
        <Button
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'feel-like',
            });
            onNext();
          }}
          title={t('onboarding.feelLike.continue')}
        />
      </div>
    </div>
  );
}

export default Page;
